<template>
	<div>
		<!-- 注文書 -->
	</div>
</template>

<script>
export default {}
</script>

<style>
</style>